// extracted by mini-css-extract-plugin
module.exports = {"vs_wrapper":"nXGto"};